module.exports = __webpack_public_path__ + "bg.0de7fdfd5705a86a6e2c.png";


//////////////////
// WEBPACK FOOTER
// /var/www/html/LASO/laso-client/src/assets/img/bg.png
// module id = ../../../../../src/assets/img/bg.png
// module chunks = main